// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap__wrap--2ED4N"};